import axios, { AxiosResponse } from 'axios';

import { EStavKontrolaMigrace } from 'enums/lei/leiDataEnums';
import { ELeiGleifStav } from 'enums/lei/leiGleifStav';

export interface ILeiSpravaUctuResp {
    stav: EStavKontrolaMigrace;
    varsymbol?: number;
    stavlei?: ELeiGleifStav;
    nazev?: string;
    ico?: string;
}

export const leiSpravaUctuApi = (lei?: string) => {
    return axios({
        method: 'GET',
        url: 'LEI/KontrolaMigrace',
        params: {
            lei: lei
        }
    }).then((resp: AxiosResponse<ILeiSpravaUctuResp>) => resp.data);
};

export const leiSpravaUctuZadostApi = (lei: string, jazyk: string) => {
    return axios({
        method: 'POST',
        url: 'LEI/Zadost',
        data: {
            jazyk: jazyk,
            lei: lei
        }
    });
};

export const leiSpravaUctuPrevodApi = (data: { lei: string; heslo: string }) => {
    return axios({
        method: 'POST',
        url: 'LEI/Prevod',
        data: data
    });
};
